/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
    const initCustom = e => {
        initSwiper();
        initBISThumbnails();
        initBISProduct();
        initSeeMore();
    }
    
    const initSwiper = e => {
        const swiperContainers = document.querySelectorAll('.swiper');
        
        swiperContainers.forEach(item => {
            const swiper = new Swiper(item, {
                autoplay: false,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                speed: 350,
                spaceBetween: 2
            });
        });
    }
    
    const initBISThumbnails = () => {
        const prodItems = Array.from(document.querySelectorAll('.product-item.monopile_product-item'));
        const bisNotifyTriggers = prodItems.filter(item => item.querySelector('.monopile-bis__notify-trigger'));
    
        bisNotifyTriggers.forEach(item => { new BISThumbnail(item); })
    }

    const BISThumbnail = function(item) {
        const notifyTrigger = item.querySelector('.monopile-bis__notify-trigger');
        notifyTrigger.addEventListener('click', e => {
            e.preventDefault();
            item.querySelector('.monopile-bis_form').classList.add('active')

        })

        const cancelTriggers = item.querySelectorAll('.monopile-bis_form-cancel');
        cancelTriggers.forEach(cancelTrigger => {
            cancelTrigger.addEventListener('click', e => {
                e.preventDefault();
                item.querySelector('.monopile-bis_form').classList.remove('active');
                item.querySelector('.monopile-bis_error-email').classList.remove('active');
                item.querySelector('.monopile-bis_container-complete').classList.remove('active');
                item.querySelector('.monopile-bis_container-form').classList.add('active');
            })
        })

        const submitTrigger = item.querySelector('.monopile-bis_form-submit')
        submitTrigger.addEventListener('click', e => {
            e.preventDefault();

            const email = (item.querySelector('.monopile-bis_input-email').value);
            if(validateEmail(email)) {
                const productId = item.getAttribute('data-productId');
                const variantId = item.getAttribute('data-variantId') === 'false' ? item.querySelector('.monopile-bis_input-variant').value : item.getAttribute('data-variantId');
    
                BIS.create(email, variantId, productId).then( data => {
                    notificationCallback(data, item)
                });
            } else {
                item.querySelector('.monopile-bis_error-email').classList.add('active');
            }
        })
    }

    const initBISProduct = () => {
        const prodItem = document.querySelector('.monopile-bis__notify-product-trigger');
        if( !prodItem ) return;

        this.currentVariant = prodItem.getAttribute('data-variantId');
        
        prodItem.classList.remove('button--disabled');
        prodItem.removeAttribute('disabled');

        prodItem.addEventListener('click', e => {
            BISPopover.show({variantId: this.currentVariant});
        })

        const onVariantChange = e => {
            const {id, available} = e.detail.variant;
            this.currentVariant = id;

            if (available) prodItem.classList.add('hidden');
            else prodItem.classList.remove('hidden');
        }

        document.addEventListener('variant:changed', onVariantChange)
    }
    
    // minimal email validating, Back in Stock API does validation
    const invalidEmailCharacters = ['&', '\'', '"', '<', '>', '/'];
    const validateEmail = email => invalidEmailCharacters.filter(character => email.includes(character)).length === 0
    
    const notificationCallback = function(data, item) {
        let msg = '';
        if (data.status == 'OK') {
            item.querySelector('.monopile-bis_container-complete').classList.add('active');
            item.querySelector('.monopile-bis_container-form').classList.remove('active');
            item.querySelector('.monopile-bis_container-complete p').innerText = data.message;
            msg = data.message; // just show the success message
        } else { // it was an error
            for (let k in data.errors) {  // collect all the error messages into a string
                msg += (data.errors[k].join());
                item.querySelector('.monopile-bis_container-complete').classList.add('active');
                item.querySelector('.monopile-bis_container-form').classList.remove('active');
                item.querySelector('.monopile-bis_container-complete p').innerText = msg;
           }
        }
    }

    const initSeeMore = () => {
        const seeMoreButtons = document.querySelectorAll('[data-see-more-trigger]');

        seeMoreButtons.forEach(item => {
            item.addEventListener('click', event => {
                const container = item.parentNode;

                if(container.classList.contains('contracted')) {
                    container.classList.remove('contracted');
                    item.innerText = 'Less';
                }
                else {
                    container.classList.add('contracted'); 
                    item.innerText = 'More';
                }
            })
        })
    }

    document.addEventListener('theme:pagechange:end', initCustom);
    
    window.addEventListener('load', event => {
        initCustom();
    });
})()
